import Vue from 'vue'
import Api from '@/api/Api'

# The settings are keyed by their name. This is easier for the frontend than the
# system the backend uses, which is key by their id. The frontend only needs the
# id when patching or deleting a settings group.

state =
    curations: {} # name to json data of settings
    curation_ids: {} # name to server-side id

mutations =
    setCuration: (state, {id, name, settings_json}) ->
        Vue.set(state.curations, name, settings_json)
        Vue.set(state.curation_ids, name, id)

    deleteCuration: (state, name) ->
        Vue.delete(state.curations, name)
        Vue.delete(state.curation_ids, name)

    changeName: (state, {oldname, newname}) ->
        Vue.set(state.curations, newname, state.curations[oldname])
        Vue.set(state.curation_ids, newname, state.curation_ids[oldname])
        Vue.delete(state.curations, oldname)
        Vue.delete(state.curation_ids, oldname)

actions =
    loadSettings: ({commit, dispatch}) ->
        Api.settings.get().then (data) =>
            for item in data
                commit('setCuration', item)
                if item.name == 'default'
                    dispatch('applySettings', item.name)

    saveCurrentSettings: ({commit, state, rootState}, name) ->
        summary = {}
        summary[item] = value for item, value of rootState.settings
        settings_json = JSON.stringify(summary)
        if name of state.curations # patch existing curation
            id = state.curation_ids[name]
            Api.settings.patch_data(id, settings_json).then (data) =>
                commit('setCuration', data)
        else # create new curation
            Api.settings.post(settings_json, name).then (data) =>
                commit('setCuration', data)

    changeName: ({commit}, {oldname, newname}) ->
        id = state.curation_ids[oldname]
        Api.settings.patch_name(id, newname).then (data) =>
            commit('changeName', {oldname, newname})

    deleteSettings: ({commit, state}, name) ->
        id = state.curation_ids[name]
        Api.settings.delete(id).then (data) =>
            commit('deleteCuration', name)

    applySettings: ({commit, state}, name) ->
        obj = JSON.parse(state.curations[name])
        for key, value of obj
            commit('setFilter', [key, value], {root: true})

export default {namespaced: true, state, mutations, actions}
